/**
 * Scheduled maintenance window (BIR-269: production Postgres volume extension).
 *
 * Times are fixed to AEST (UTC+10). Update START/END for the next window, or
 * leave them in the past to hide the banner without a code change elsewhere.
 */
export const MAINTENANCE_WINDOW = {
  start: new Date('2026-09-04T10:00:00+10:00'),
  end: new Date('2026-09-04T10:30:00+10:00'),
  // Human copy shown in the banner. Kept as text so it reads the same for
  // every user regardless of their browser timezone.
  label: 'Friday 4 September, 10:00 to 10:30 AEST',
};

/** Dismissal persists in localStorage and resets at the user's local midnight. */
export const DISMISS_STORAGE_KEY = 'maintenance-banner-dismissed-on';

const localDateKey = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
    d.getDate(),
  ).padStart(2, '0')}`;

export const todayKey = () => localDateKey(new Date());

/** Banner is visible from deploy until the window closes. */
export const isWindowUpcoming = (now = new Date()) =>
  now.getTime() < MAINTENANCE_WINDOW.end.getTime();

/**
 * When the browser is not on Australian east-coast time, also show the window
 * in the viewer's local time so overseas users do not have to convert.
 */
export const localWindowLabel = (): string | null => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (
      tz &&
      /^Australia\/(Sydney|Melbourne|Brisbane|Canberra|Hobart)$/.test(tz)
    ) {
      return null;
    }
    const time = new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
    });
    const day = new Intl.DateTimeFormat(undefined, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZoneName: 'short',
    });
    const { start, end } = MAINTENANCE_WINDOW;
    return `${day.format(start)}, ${time.format(start)} to ${time.format(end)}`;
  } catch {
    return null;
  }
};
